import { VebinarModal } from './ui/VebinarModal.jsx'

export default VebinarModal
